export default __webpack_public_path__ + "static/media/4yeux.7fb6219e.jpg";